module.exports = __webpack_public_path__ + "images/b7171b0e.png";